import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';
import {Container, TitleContainer} from 'pages/june-5/races/components/SummaryList'

const TitleContainerFiller = styled.div`
	min-width: 20%;
	@media screen and (max-width: 767px) {
		width: 90%;
		border: none;
		margin: 0 auto;
		text-align: center;
	}
`;

const Title = styled.h3`
	margin-top: 30px;
	margin-bottom: 20px;
	text-align: center;
`;

const Datum = styled.div`
	width: calc(70% - 40px);
	padding-right: 20px;
	box-sizing: border-box;
	@media screen and (max-width: 767px) {
		width: 90%;
		margin: 10px auto;
		&::before {
			content: "${props=>props.beforeText}";
		}
	}
`;



const BodyCenter = Datum.extend`
	text-align: center;
`;

const CompareBlock = (props)=> {
	const {rowData, firstColTitle, secondColTitle, title, beforeText1, beforeText2} = props.data;
	const rows = rowData.map( (row, i) => {	
		const rowElements = row.map( (datum, j) => {
			if (j === 1) {
				return <Datum beforeText={beforeText1} key={j}>{row[j]}</Datum>
			}
			else if (j === 2) {
				return <Datum beforeText={beforeText2} key={j}>{row[j]}</Datum>
			}
			return null;
		});
		return(
			<Container key={i}>
				<TitleContainer>
					<h3>{row[0]}</h3>
				</TitleContainer>
				{rowElements}
			</Container>
		);
	});

	return(
			<Row>
		    <Col
		    	xsOffset={0} xs={12}
		      smOffset={1} sm={10}
		      mdOffset={2} md={8}
		      lgOffset={2} lg={8}
		    >
					<Title>{title}</Title>
					<Container>
						<TitleContainerFiller/>
						<BodyCenter><h4>{firstColTitle}</h4></BodyCenter>
						<BodyCenter><h4>{secondColTitle}</h4></BodyCenter>
					</Container>
					{rows}
				</Col>
			</Row>
	);
}

export default CompareBlock;


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/CompareBlock.js